var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 221.3",
    style: {
      enableBackground: "new 0 0 70 221.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.6,1.4c0.3,15.5-0.9,23.4,3.2,41.1c1.5,6.6,4.7,14.7,11.4,23.3C48.3,77.4,56,78.5,62.1,89 c4.8,8.3,5.4,16.9,5.2,22.7v-2.9c0.2,5.8-0.4,14.4-5.2,22.7C56,142,48.3,143,39.2,154.7c-6.7,8.6-9.9,16.7-11.4,23.3 c-4.1,17.7-2.9,25.6-3.2,41.1H1.4V1.3L24.6,1.4z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArch);
export default __webpack_public_path__ + "static/media/arch.d1c1a9fe.svg";
export { ForwardRef as ReactComponent };